import React from 'react'
import ButtonPage from './basic/ButtonPage'

function ThemeComponent() {
  return (
    <>
        <div className='d-flex flex-column'>
            <ButtonPage/>
        </div>
    </>
  )
}

export default ThemeComponent